'use strict';

/* Views */
import ReservationList from './list/reservation-list.component';
import ReservationAdmin from './admin/reservation-admin.component';

/* Components */
import ReservationAddComponent from '../../components/reservation-add/reservation-add.component';

/* Services */
import ReservationService from '../../services/reservation/reservation.service';

export default angular.module('conduuApp.reservation', [ReservationList, ReservationAdmin, ReservationAddComponent, ReservationService])
  .name;



// WEBPACK FOOTER //
// ./client/app/reservation/index.js